import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, setDisplayName, setPropTypes, defaultProps } from 'recompose';
import styles from './FieldContainer.scss';

export const FieldContainer = ({ children, className, fullSize }) => (
  <div className={
        classnames(
            className,
            styles.root,
            'mc-fieldContainer',
            { 'mc-fieldContainer_fullsize': fullSize },
)}
    >
    {children}
  </div>
);

export default compose(
  setDisplayName('FieldContainer'),
  defaultProps({
    className: '',
  }),
  setPropTypes({
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
  }),
)(FieldContainer);
